import { API_DOMAIN } from '@/api/trpc';
import type {
    AuditMetricScope,
    BackendIssueStatus,
    FeatureAuditQueueScope,
    ParameterDiscoveryMetric,
    ScorecardGenerationCandidateScope,
    ScorecardGenerationExternalTool
} from './types';

export const activeBackendIssueStatuses: BackendIssueStatus[] = ['open', 'triaged', 'codex_queued'];
export const activeAiIssueTriageRunStatuses = new Set(['pending', 'running']);

export const auditMetricScopeOptions: { value: AuditMetricScope; label: string }[] = [
    { value: 'stock', label: 'Stock' },
    { value: 'options', label: 'Options' },
    { value: 'both', label: 'Both' }
];

export const scorecardMetricOptions: { value: ParameterDiscoveryMetric; label: string }[] = [
    { value: 'stock', label: 'Stock' },
    { value: 'options', label: 'Options' }
];

export const scorecardGenerationToolOptions: { value: ScorecardGenerationExternalTool; label: string }[] = [
    { value: 'codex', label: 'Codex' },
    { value: 'claude_code', label: 'Claude Code' },
    { value: 'chatgpt', label: 'ChatGPT' },
    { value: 'claude', label: 'Claude (Web & Desktop)' },
    { value: 'cursor', label: 'Cursor' }
];

export const scorecardGenerationScopeOptions: { value: ScorecardGenerationCandidateScope; label: string }[] = [
    { value: 'all_diagnostics', label: 'All Features' },
    { value: 'authoring_pool', label: 'Authoring Pool' }
];

export const featureAuditQueueScopeOptions: { value: FeatureAuditQueueScope; label: string }[] = [
    { value: 'needs_review', label: 'Needs Review' },
    { value: 'all_diagnostics', label: 'All Diagnostics' }
];

export const toolLaunchUrls: Partial<Record<ScorecardGenerationExternalTool, string>> = {
    chatgpt: 'https://chatgpt.com/',
    claude: 'https://claude.ai/new',
    cursor: 'https://cursor.com/'
};

export const project314McpEndpoint = `${API_DOMAIN}/mcp`;
export const developerAccessPath = '/user/developerAccess';
